import { jsx as _jsx } from "react/jsx-runtime";
import { Facet } from "@elastic/react-search-ui";
import { observer } from "mobx-react-lite";
import { useContext } from "react";
import "@elastic/react-search-ui-views/lib/styles/styles.css";
import config from "../../config";
import { UIStateStoreContext } from "../../stores/uiStateStore";
/**
 * Renders sub category filters.
 */
export const SubFacets = ({ openCategory }) => {
    const facets = config.services[openCategory].facetList;
    return (_jsx("div", { className: "sub-facets", children: (facets || []).map((facet, i) => {
            return (_jsx(Facet, { field: facet.field, filterType: facet.filterType, label: facet.label, show: 10, view: facet.view }, i));
        }) }));
};
/**
 * Renders sidebar facets (=filters).
 */
export const Facets = observer(() => {
    const uiStore = useContext(UIStateStoreContext);
    const service = uiStore.inGlobalSearchMode()
        ? config.global
        : config.services[uiStore.getService()];
    return (_jsx("div", { className: "facet-list", "data-testid": "facetList", children: !!service.facetList &&
            service.facetList.map((facet, i) => {
                return (_jsx(Facet, { field: facet.field, filterType: facet.filterType, label: facet.label, show: 10, view: facet.view }, i));
            }) }));
});
